import React from 'react';
import { ClassSongMap } from './ClassSongMap';

export function ClassSessionControls({ tracks = [], classSession, onBuild, bpm, onAddMarkers, classHighlight, focus = true, canToggleFocus = false, onToggleFocus, contextLabel = 'Class preview' }) {
  if (!classSession) return null;
  const picked = tracks.filter((track) => track.classSlot && !track.muted).length;
  return <section className="class-session-controls" data-testid="class-session-controls">
    <div className="class-session-title"><strong>{classSession.packName}</strong><span>{contextLabel}</span></div>
    {canToggleFocus && <button className="class-focus-toggle" data-testid="class-focus-toggle" aria-pressed={focus} onClick={() => onToggleFocus?.(!focus)}><span>Focus mode</span><strong>{focus ? 'On' : 'Off'}</strong><i /></button>}
    {classSession.phase === 'pick' && <>
      <button className="class-build-button" data-testid="build-my-beat" disabled={picked < 2} onClick={onBuild}>Build my beat</button>
    </>}
    {classSession.phase === 'arrange' && <ClassSongMap bpm={bpm} flow={classSession.flow} mapId={classSession.mapId} onAddMarkers={onAddMarkers} highlighted={classHighlight?.targetId === 'add-class-markers'} />}
  </section>;
}

export default ClassSessionControls;
